import { createCommand } from '../../utils';
import { filterUpdated, moduleName } from '../state';
import type { ProjectSectionFilter } from '../../domain/Project';

const FilterProjectCommand = createCommand(
    `${moduleName}/FILTER_PROJECT`,
    async (filter: ProjectSectionFilter, { dispatch, extra }) => {
        extra.externalProjectConfiguration.saveProjectSectionsFilter(filter);
        dispatch(filterUpdated(filter));
    },
);

export default FilterProjectCommand;
